import React, { useState, useEffect } from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { grey, green } from '@mui/material/colors';
import Checkbox from "@mui/material/Checkbox";

const GreenCheckbox = (props) => <Checkbox className="ml-2 mr-3 p-0" sx={{
  color: grey[600],
  '&.Mui-checked': {
    color: '#25d366',
  },
}} {...props} />;

const CheckVisibility = ({field, tableRef}) => {

  const [visibility, setVisibility] = useState(false);

  const handleChangeCheckBox = () => {
    setVisibility(!tableRef.current?.columnApi?.getColumn(field.field).visible);
    tableRef.current?.columnApi?.setColumnVisible(field.field, !tableRef.current?.columnApi?.getColumn(field.field).visible)
  }

  useEffect( ()=> {

    setVisibility(tableRef.current?.columnApi?.getColumn(field?.field)?.visible)

  },[])

  return  <div className="px-2 py-1 d-flex align-items-center">
    <GreenCheckbox
      id={'header'+field.field}
      checked={visibility || false}
      icon={<VisibilityOffIcon/>}
      checkedIcon={<VisibilityIcon/>}
      onChange={() => handleChangeCheckBox()}
    />
    <h4 className="m-0" style={{fontSize:'1rem',color:'dimgrey'}}><strong>{field.headerName}</strong></h4>
  </div>

}

function VisibilityColumns({ properties }) {

  const { tableRef } = properties;
  const [filter, setFilter] = useState("");

  const handleChangeFilter = (value) => {
    setFilter(value)
  }

  useEffect(() => {

    // console.log(tableRef.current?.api?.getColumnDefs())

  }, [tableRef])

  return (
    <div>
      <div className="d-flex align-items-center" action="#"
           style={{width: '100%', border: '1px solid rgb(189, 195, 199)', borderRadius: '0.2rem', boxShadow: 'rgba(0, 0, 0, 0.1) 0px 2px 5px 0px'}}>
        <div className="input-group bg-blanco heigh-input-search">
          <div className="input-group-prepend bg-transparent heigh-input-search">
            <i className="input-group-text border-0 mdi mdi-magnify clr-gray"
               style={{backgroundColor: 'white'}}/></div>
          <input type="text"
                 name="filterList"
                 onChange={({target: {value}}) => handleChangeFilter(value)}
                 className="pl-0 heigh-input-search clr-gray form-control border-0"
                 placeholder="Buscar Columna..." style={{backgroundColor: 'white'}}/>
        </div>
      </div>
      <hr className="mt-3 mb-2"/>
      {
        tableRef.current?.api?.getColumnDefs()?.filter(el => el.headerName.toLowerCase().includes(filter.toLowerCase())).map((field, index)=>{
          return <CheckVisibility key={index} field={field} tableRef={tableRef}  />
        })
      }
    </div>
  );
}

export default VisibilityColumns;
